import React from "react";
import contextProvider from "../../contextProvider";
import Cookies from "universal-cookie";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../_L1_components/Layout/Panel";
import ReactOForm from "../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../_L1_components/Elements/ReactOFormInput";

class Login extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      disableSubmit: true,
    };
    super(props, initState);
    this.cookies = new Cookies();
    this.errorMessages = {
      USER_NOT_FOUND: "Utente o password errati o inesistenti",
    };
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    // console.log("DEBUG :: Login _ onComponentDidMoun");
    // this.cookies.remove("reacto_auth", { path: "/", domain: ".inrete.it" });
    // const arr = host.split(".").slice(0, host.includes("localhost") ? -1 : -2);

    this.getAppContext().getLocalStorageService().remove("prevSelectedTags");
    this.getAppContext().getLocalStorageService().remove("goBackTags");
    this.getAppContext().getLocalStorageService().remove("goBackExplorer");

    if (this.getAppContext().authHandler.isAuthorized()) {
      this.getAppContext().redirectTo("_HOME_");
    } else {
      this.cookies.remove("reacto_auth", { path: "/" });
      this.cookies.remove("reacto_auth", { path: "/", domain: ".inrete.it" });
      this.cookies.remove("reacto_auth", {
        path: "/",
        domain: "wifiprobe.inrete.it",
      });
      this.cookies.remove("reacto_auth", {
        path: "/",
        domain: "netprobe.inrete.it",
      });
      this.cookies.remove("reacto_auth", {
        path: "/",
        domain: "appprobe.inrete.it",
      });
    }
    this._login_form.init();
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mx-auto mt-4"
          style={{
            width: "300px",
          }}
          rounded
          header={<h3 className="text-center text-secondary">SIGN IN</h3>}
        >
          <ReactOForm
            submitOnEnterKey={!this.state.disableSubmit}
            onSubmit={(form_data, cb) => {
              this.setState({ loading: true }, () => {
                this.getAppContext().authHandler.login(
                  form_data,
                  (status, data, wrongPlatform) => {
                    this.setState(
                      {
                        loading: false,
                        ...(status == "NOT_AUTHENTICATED"
                          ? { displayedErrorMessage: data }
                          : { displayedErrorMessage: null }),
                      },
                      () => {
                        if (cb) {
                          cb(
                            status,
                            data == "ACCOUNT_NOT_EXISTS"
                              ? "Wrong credentials"
                              : data,

                            () => {
                              if (status == "OK") {
                                if (wrongPlatform) {
                                  // window.location.href = `http://${wrongPlatform}`;
                                } else {
                                  if (
                                    this.getAppContext().authHandler.getAccountData()
                                      .message
                                  ) {
                                    this.getAppContext().redirectTo("/static");
                                  } else {
                                    console.log(
                                      "this.getAppContext().getPostLoginRedirect()",
                                      this.getAppContext().getPostLoginRedirect(),
                                    );
                                    if (
                                      this.getAppContext().getPostLoginRedirect() &&
                                      this.getAppContext().getPostLoginRedirect() !=
                                        this.getAppContext().loginRoute
                                    ) {
                                      console.log(
                                        "this.getAppContext().getPostLoginRedirect();",
                                        this.getAppContext().getPostLoginRedirect(),
                                      );
                                      let _TMP_redirTo =
                                        this.getAppContext().getPostLoginRedirect();
                                      this.getAppContext().setPostLoginRedirect(
                                        undefined,
                                      );
                                      this.getAppContext().redirectTo(
                                        _TMP_redirTo == "/dashboard"
                                          ? "_HOME_"
                                          : _TMP_redirTo,
                                      );
                                    } else {
                                      this.getAppContext().redirectTo("_HOME_");
                                    }
                                  }
                                }
                              }
                            },
                          );
                        }
                      },
                    );
                  },
                );
              });
            }}
            onControllerReady={(form_controller) => {
              this._login_form = form_controller;
            }}
            onFormDataChange={(new_data) => {
              if (
                this._login_form.getFormData().user &&
                this._login_form.getFormData().password
              ) {
                this.setState({
                  disableSubmit: false,
                });
              } else {
                this.setState({
                  disableSubmit: true,
                });
              }
            }}
            preSubmit={(submitting_data) => {
              return submitting_data;
            }}
          >
            <ReactOFormInput
              type="text"
              label="USERNAME"
              data_key="user"
              placeholder="Username"
              size="md"
              className="mb-2" // default="neelvio"
              autofocus
              validators={[
                {
                  func: (value) => {
                    return value != "";
                  },
                },
              ]}
            />
            <ReactOFormInput
              type="password"
              realPwd
              label="PASSWORD"
              data_key="password"
              placeholder="Password"
              size="md"
              className="mb-4" // default="test"
              validators={[
                {
                  func: (value) => {
                    return value != "";
                  },
                },
              ]}
            />
            {/*
						<ReactOFormInput type="checkbox" data_key="remember" label="Remember me" size="md"// default="test"
						//	validators={[
						//		{
						//			func: (value) => {
						//				return true;
						//			}
						//		}
						//	]}
						/>
						*/}
            <ReactOFormInput
              type="error_display"
              className="text-danger text-center mb-3"
            />
            {/*this.errorMessages[this.state.displayedErrorMessage] ? (<Alert className="text-center" color="danger">{this.errorMessages[this.state.displayedErrorMessage]}</Alert>) : null*/}
            <ReactOFormInput
              disabled={this.state.disableSubmit}
              className="w-100"
              type="submit"
              color="primary"
              size="lg"
            >
              Login
            </ReactOFormInput>
          </ReactOForm>
        </Panel>

        <Panel
          className="mx-auto mt-1 text-center"
          noBorder
          bgColor
          style={{
            width: "300px",
          }}
        >
          {this.getAppContext().isCloud() &&
          this.getAppContext().platformName() == "WiFiProbe" ? (
            <a
              href="/viewer/wfp_quick_guide.pdf"
              style={{ textDecoration: "none", color: "inherit" }}
              target="_blank"
            >
              <span style={{ color: "#495057" }}>Quick guide (PDF)</span>
            </a>
          ) : null}
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(Login, {
  define: null,
  retrieve: null,
});
